var exports = {
  "mz": "TextCell__t9hUSk",
  "N_": "Link__x8mIvq",
  "rF": "wrapping__6kAcxN",
};

module.exports = exports;
